export default __webpack_public_path__ + "static/media/31-WalkInTheMeadow.654df034.jpeg";